const epsFor = (price) => Math.max(Math.abs(price) * 1e-8, 1e-8);
const isFlatBar = (bar) => {
    const eps = epsFor(bar.close);
    return Math.abs(bar.high - bar.low) <= eps && Math.abs(bar.open - bar.close) <= eps;
};
/**
 * Убирает ночное/неторговое плато: подряд одинаковые flat-бары
 * (воркер пишет last price каждую минуту даже без сделок).
 */
export function compressInactiveBars(bars) {
    if (bars.length === 0)
        return [];
    const out = [];
    for (const bar of bars) {
        if (out.length === 0) {
            out.push(bar);
            continue;
        }
        const prev = out[out.length - 1];
        if (isFlatBar(bar) &&
            isFlatBar(prev) &&
            Math.abs(bar.close - prev.close) <= epsFor(bar.close)) {
            continue;
        }
        out.push(bar);
    }
    return out;
}
/** «Объём» для графика: реальный volume в истории нет — берём ценовой диапазон бара. */
export function barActivityVolume(bar) {
    const range = Math.max(bar.high - bar.low, Math.abs(bar.close - bar.open), 0);
    if (range > 0)
        return range;
    // Полностью плоский бар — минимальный хвост, чтобы не доминировал на шкале.
    return Math.max(Number(bar.samples) || 1, 1) * 1e-6;
}
/**
 * Агрегация минутных OHLC в N-минутные бары (по UTC-минутам bucket).
 * samples суммируются; для volume на графике лучше barActivityVolume после агрегации.
 */
export function aggregateOhlcBars(bars, timeframeMin) {
    if (timeframeMin <= 1 || bars.length === 0)
        return bars.slice();
    const bucketMs = timeframeMin * 60000;
    const out = [];
    let cur = null;
    let curBucket = -1;
    for (const bar of bars) {
        const bucket = Math.floor(bar.ts / bucketMs);
        if (cur == null || bucket !== curBucket) {
            if (cur)
                out.push(cur);
            cur = { ...bar };
            curBucket = bucket;
            continue;
        }
        cur = {
            ...cur,
            high: Math.max(cur.high, bar.high),
            low: Math.min(cur.low, bar.low),
            close: bar.close,
            samples: (cur.samples ?? 0) + (bar.samples ?? 0),
            // ts — начало/первая минута бакета (уже задано)
        };
    }
    if (cur)
        out.push(cur);
    return out;
}
